module.exports = __webpack_public_path__ + "static/img/mini-bus-green.989f126.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/mini-bus-green.svg
// module id = dgd6
// module chunks = 74